<script setup lang="ts">
import i18n from "@/lang/i18n";

const emit = defineEmits(['download']);

const props = defineProps<{
  downloading: boolean,
  isShowableDownloadButton: boolean
}>()
</script>
<template>
  <div class="form-footer p-2">
    <router-link
      :to="{ name: props.downloading ? null : 'Every24hoursReport' }"
      :class="{ 'disabled-link': props.downloading }"
    >
      <v-btn
        class="m-1 reset-btn"
        :disabled="props.downloading"
      >
        {{ i18n.global.t('pages.every24HoursReport.preview.returnPage') }}
      </v-btn>
    </router-link>
    <v-btn
      v-if="isShowableDownloadButton"
      class="m-1 exec-btn"
      :loading="props.downloading"
      @click="emit('download')"
    >
      {{ i18n.global.t('common.downloadBtn') }}
    </v-btn>
  </div>
</template>
<style scoped>
.disabled-link {
  pointer-events: none;
  color: gray;
  cursor: not-allowed;
  text-decoration: none;
}
</style>
